import { Reveal, Tag, ArrowLink } from "../components/Shared";
import { INSTA_IMAGES, TESTIMONIALS } from "../data/content";
import { Instagram, Quote } from "lucide-react";

const Social = () => (
  <section className="bg-ink px-5 py-28 sm:px-10 md:py-40" data-testid="social-section">
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Reveal><Tag>The Social Moment</Tag></Reveal>
          <h2 className="mt-6 font-serif text-5xl font-light tracking-tight sm:text-6xl lg:text-7xl">FOLLOW THE <span className="text-fog">LOOK</span></h2>
          <Reveal delay={0.2}><p className="mt-4 text-lg font-light text-fog">See what's happening between the collections.</p></Reveal>
        </div>
        <Reveal delay={0.25}>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="instagram-follow-link" className="group inline-flex items-center gap-3 border border-line/15 px-6 py-3.5 font-mono text-[10px] uppercase tracking-[0.3em] text-bone transition-all duration-300 hover:border-flame hover:text-flame">
            <Instagram className="h-4 w-4" /> @rutubhonsle
          </a>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6" data-testid="instagram-grid">
        {INSTA_IMAGES.map((src, i) => (
          <Reveal key={src} delay={i * 0.06}>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="group relative block aspect-square overflow-hidden" data-testid={`insta-tile-${i}`}>
              <img src={src} alt={`Rutu Bhonsle on Instagram — look ${i + 1}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
              <span className="absolute inset-0 flex items-center justify-center bg-ink/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <Instagram className="h-6 w-6 text-flame" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>

      <div className="mt-32">
        <Reveal><Tag>Testimonials</Tag></Reveal>
        <h2 className="mt-6 font-serif text-5xl font-light tracking-tight sm:text-6xl lg:text-7xl">
          WORN. LOVED. <span className="text-flame">REMEMBERED.</span>
        </h2>
        <div className="mt-14 grid gap-px bg-line/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-ink">
              <figure className="flex h-full flex-col p-9 transition-colors duration-500 hover:bg-coal" data-testid={`testimonial-${i}`}>
                <Quote className="h-5 w-5 text-flame" />
                <blockquote className="mt-5 flex-1 font-serif text-xl font-light italic leading-snug text-bone/90">“{t.quote}”</blockquote>
                <figcaption className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-fog">
                  {t.by} — <span className="text-flame">{t.place}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Social;
